import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const API_URL = config.backendUrl

// ===============================
// 1. GET ALL Parts Inventory
// ===============================
export const getAllPartsInventory = createAsyncThunk(
    "partsInventory/getAll",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${API_URL}/partsinventory/all`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// ===============================
// 2. CREATE OR UPDATE Parts Inventory
// ===============================
export const createOrUpdatePartsInventory = createAsyncThunk(
    "partsInventory/createOrUpdate",
    async (payloadArray, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`${API_URL}/partsinventory/add`, payloadArray);
            return response.data; // returns array of created/updated items
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// ===============================
// 3. DELETE Parts Inventory Item
// ===============================
export const deletePartsInventory = createAsyncThunk(
    "partsInventory/delete",
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${API_URL}/partsinventory/delete/${id}`);
            return response.data.data; // return deleted record
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// ===============================
// Slice
// ===============================
const partsInventorySlice = createSlice({
    name: "partsInventory",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
            // GET ALL
            .addCase(getAllPartsInventory.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllPartsInventory.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.error = null;
            })
            .addCase(getAllPartsInventory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // CREATE / UPDATE
            .addCase(createOrUpdatePartsInventory.pending, (state) => {
                state.loading = true;
            })
            .addCase(createOrUpdatePartsInventory.fulfilled, (state, action) => {
                state.loading = false;

                // Replace entire list with updated array
                // Because API returns all updated/new items
                state.data = action.payload;
                state.error = null;
            })
            .addCase(createOrUpdatePartsInventory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // DELETE
            .addCase(deletePartsInventory.pending, (state) => {
                state.loading = true;
            })
            .addCase(deletePartsInventory.fulfilled, (state, action) => {
                state.loading = false;

                // Remove deleted item from state
                state.data = state.data.filter(
                    (item) => item._id !== action.payload._id
                );

                state.error = null;
            })
            .addCase(deletePartsInventory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default partsInventorySlice.reducer;
